/*
|--------------------------------------------------------------------------
| Views: Article
|--------------------------------------------------------------------------
*/

/**
 * Featured Single
 * @namespace
 */
__gh__webApp.views.article = {

	/**
	 * Post bucket laydown callbacks
	 * @param {object} bucket - bucket object
	 */
	"callbacks": function(bucket){

		var utilities		= __gh__webApp.utilities,
			articleJSON		= bucket.items.main[0],
			articlePage		= __gh__webApp.articlePage,
			trackArticle	= __gh__webApp.utilities.tracker.trackArticle;

		articlePage.loadArticle.callbacks({"articleObject":articleJSON,"articleDOM":"#article"});
		if( __gh__coreData["3rdPartyData"].ads.dfp.consumerSurvey != 'true'){
			articlePage.consumerSurvey.showSurvey();
		}
		trackArticle.mainArticle({"articleObject":articleJSON});
	},

	"prepItemData": function(items){
		var item 						= items[0],
			relatedTypes				= [],
			relatedItems 				= item.relatedContent.items,
			firstGallery 				= true,
			firstGalleryDuplicateCheck	= false;
			
		items[0].image = {};

		//Related types array to check for related icons in view
		for(var i=0; i<relatedItems.length; i++){
			var relatedItem 			= relatedItems[i],
				type 					= relatedItem.type;
				type 					= (type == "images") ? "gallery" : type;
			var	isGallery				= (type=="gallery"),
				isMainImage				= (type=="mainImage");
				
				if(relatedItem.items.length){
					relatedTypes.push(type);
				}
				
				//Add Main image to image node for easy access			
				if (isMainImage){
					items[0].image = (relatedItem.items.length > 0) ? relatedItem.items[0] : items[0].image;
				}
				
				//Remove duplicate galleries that get added by GalleryConnectionItems
				if (isGallery && firstGalleryDuplicateCheck == relatedItem.title + relatedItem.link){
					items[0].relatedContent.items.splice(i,1);
				}
				//First Gallery
				if(relatedItem.items.length && isGallery && firstGallery){
					firstGalleryDuplicateCheck 	= relatedItem.title + relatedItem.link;
					firstGallery 				= false;
				}
		}
		items[0].relatedContent.types = relatedTypes;
		
		return items;
	},
	
	/**
	 * Get a subview for the article..ie.Imagelist
	 */
	"getArticleSubView": function(bucket){
		var commonJS 		= __gh__webApp.common,
			views			= __gh__webApp.views,
			articleObject	= bucket.items.main[0];
			
		if (commonJS.isObjectPropertySet(articleObject,"subView") && commonJS.isObjectPropertySet(views, "article"+articleObject.subView + ".getSubView")){
			return views["article"+articleObject.subView].getSubView(bucket)
		}
		
		return false;
	},


	"getSubView": function(bucket){
		var items				= bucket.items.main;
		
		// Prep Article
		bucket.items.main		= this.prepItemData(items);
		
		var articleSubView 		= this.getArticleSubView(bucket)
		if (articleSubView){
			return articleSubView;
		}
		
		bucket.view.name = "buckets/article/default";
		return bucket;

	}
};